<!--
 * @Author: zyy
 * @Date: 2023-09-06 11:35:47
 * @LastEditTime: 2023-09-06 15:17:06
 * @FilePath: /tjzhsq-admin/src/views/platform/vip/experience/edit.vue
 * @Description: yahu~
 * 
-->
<template>
    <a-modal :title="title" v-model="show" @ok="confirmModal" destroy-on-close width="60%" centered>
        <a-form-model ref="formRef" :model="formData" :rules="rules" style="width: 600px;">
            <a-form-model-item label="成长值" prop="points">
                <a-input v-model="formData.points" placeholder="请输入成长值" allow-clear></a-input>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>

<script >
import { setFormData } from '@/plugins/utils.js'
import ExpService from '@/io/vip/exp.js'

export default {
    name: 'LevelEdit',
    emits: ['close', 'submit'],
    data() {
        return {
            title: '新增',
            show: false,
            loading: false,
            formData: {
                id: undefined,
                points: undefined
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: '请输入等级名称'
                    }
                ],
                points: [
                    {
                        required: true,
                        message: '请输入成长值'
                    }
                ]
            }
        }
    },
    methods: {
        open(data) {
            this.title = data ? '编辑' : '新增'
            this.show = true
            if (data) setFormData(data, this.formData)
        },
        close() {
            this.show = false
            this.$emit('close')
        },
        confirmModal() {
            this.$refs.formRef.validate(async valid => {
                if (valid) this.formData.id ? await ExpService.edit(this.formData) : await ExpService.add(this.formData)
                this.$message.success(`${this.formData.id ? '编辑' : '新增'}成功`)

                this.$emit('submit')
                this.close()
            })



        }
    }
}

</script>


